// This is separate from "record-references.ts" to avoid a load cycle.
export const RECORD_REFERENCES_VERSION = '2';
